import styled from '@emotion/styled';

import { LabelElementProps } from './types';

export const LabelElement = styled.div<LabelElementProps>`
  padding: ${({ padding }) => padding};
  cursor: ${({ button }) => (button ? 'pointer' : 'inherit')};
  font-family: ${({ theme }) => theme.font_family};
  font-size: ${({ theme }) => theme.font_size};
  line-height: ${({ theme }) => theme.line_height};
`;
